const colors = require("../../src/styles/colors");

module.exports = {
  siteTitle: "you-phoria", // <title>
  shortSiteTitle: "you-phoria", // <title> ending for posts and pages
  siteDescription: "Writings of Cal Roach.",
  siteUrl: "http://www.you-phoria.com",
  pathPrefix: "",
  siteImage: "preview.jpg",
  siteLanguage: "en",
  // author
  authorName: "Cal Roach",
  authorTwitterAccount: "@roachcraft",
  // info
  infoTitle: "you-phoria",
  infoTitleNote: "by cal roach",
  // manifest.json
  manifestName: "you-phoria",
  manifestShortName: "you-phoria", // max 12 characters
  manifestStartUrl: "/",
  manifestBackgroundColor: colors.bg,
  manifestThemeColor: colors.bg,
  manifestDisplay: "standalone",
  // social
  authorSocialLinks: [
    { name: "twitter", url: "https://twitter.com/roachcraft" },
  ],
  disqusShortname: "youphoria"
};



// WEBPACK FOOTER //
// ./content/meta/config.js